<script setup lang="ts">
import type { FlexProps } from '/#/components/base/flex/flex'

const props = withDefaults(defineProps<FlexProps>(), {
  flexDirection: 'row',
  flexWrap: 'nowrap',
  justifyContent: 'normal',
  alignItems: 'normal',
  alignContent: 'normal',
  rowGap: 'normal',
  columnGap: 'normal',
  inline: false,
})

const display: ComputedRef<'inline' | 'flex'> = computed(() =>
  props.inline ? 'inline' : 'flex',
)
</script>

<template>
  <div class="v-flex">
    <slot />
  </div>
</template>

<style lang="scss">
.v-flex {
  display: v-bind(display);
  flex-direction: v-bind('props.flexDirection');
  flex-wrap: v-bind('props.flexWrap');
  justify-content: v-bind('props.justifyContent');
  align-items: v-bind('props.alignItems');
  align-content: v-bind('props.alignContent');
  row-gap: v-bind('props.rowGap');
  column-gap: v-bind('props.columnGap');
}
</style>
